/**
 * colorMix — apply an alpha to a colour that may be a CSS variable.
 *
 * The codebase used to write `${C.accent}55`, which worked while the palette
 * was literal hex: '#0084f8' + '55' is a valid 8-digit hex. Once the palette
 * became `var(--fbd-accent, #0084f8)`, the same expression produced
 * `var(--fbd-accent, #0084f8)55` — not a colour at all, so the declaration was
 * dropped and the border or tint silently disappeared. That is what removed the
 * outline from the onboarding card.
 *
 * color-mix() takes the var() properly. Percentages here are the old hex alpha
 * converted (0x55 / 0xff ≈ 33%), so the rendered result matches what the design
 * had before.
 */
export function colorMix(color: string | null | undefined, percent: number): string {
  if (!color) return 'transparent';
  return `color-mix(in oklab, ${color} ${percent}%, transparent)`;
}
